export class SocialAuthentication {
    literalFbTags: string;
    dvDouble: boolean;
    dvSingle: boolean;
    spanfb: boolean;
    SocialAuthHead: string;
    SocialAuthHead1: string;
    SocialAuthMsg: string;
    SocialAuthMsg1: string;
    SocialAuthBtnText: string;
    SocialAuthBtnText2: string;
    SocialAuthBtnText3: string | null;
    isDenied: boolean;
    isPoweredByClient: boolean;
    isSubscriptionModal: boolean;
    strPrivacyPolicy: string;
    strProductHostUrl: string;
    FacebookKey: string;
    LinkedInKey: string;
    IsRedirectToSurvey: boolean;
    UserDataValues: string;
    isOnlyFacebook: boolean;
    isOnlyLinkedIn: boolean;
    isFacebookLinkedIn: boolean;
}

export class SocialAuthUrlParams {
    k: string;
    code: string;
    error: string;
    surveyKeyAfterAuth: string;
}
